import { getGsap, GSAP, ScrollTrigger, Timeline, Tween } from '@/gsap';
import { bus } from '@/bus';
import select from 'dom-select';
import type SlSelect from '@shoelace-style/shoelace/dist/components/select/select.js';
import { cl, isDesktop, Observer } from '@/utils';

let gsap: GSAP;
let scrollTrigger: ScrollTrigger;
let animations: Timeline|Tween[] = [];
let mm = null;

function sectionReveal(parent: HTMLElement) {
  const trigger = select.all('.section-reveal', parent);
  trigger.forEach((trigger) => {

    const fromBottom = trigger.getAttribute('data-reveal-bottom') === '';
    const rootMargin = fromBottom ? '0% 0% 10% 0%' : isDesktop(1024) ? '0% 0% -30% 0%' : '0% 0% -10% 0%';
    const { bottom } = trigger.getBoundingClientRect();
    if (bottom < window.innerHeight) {
      cl(trigger).add('section-revealed');
    }

    const observer = new Observer({
      rootMargin,
      class: 'section-revealed',
    });

    observer.add(trigger);
  });
}

function headerBits() {
  const header = select('header.header');
  const navInner = select('.nav-inner', header);
  const headerTime = select('[data-anim-el="header-time"]', header);
  const logoDenver = select('svg #denver', header);
  const hoverTargets = select.all('[data-anim-el="header-hover-el"]', header);
  const hoverEl = select('[data-anim-el="header-hover"]', header);

  if (headerTime) {
    const timeline = gsap.to(headerTime, {
      opacity: 0,
      scrollTrigger: {
        trigger: header,
        scrub: true,
        start: 'top top',
        end: 'top -4%',
      }
    });

    animations.push(timeline);
  }

  if (logoDenver) {
    const timeline = gsap.to(logoDenver, {
      opacity: 0,
      scrollTrigger: {
        trigger: header,
        scrub: true,
        start: 'top top',
        end: 'top -7%',
      }
    });

    animations.push(timeline);
  }
  scrollTrigger.refresh();

  navInner.addEventListener('mouseleave', () => {
    navInner.classList.remove('has-hovered');
  });

  hoverTargets.forEach((target) => {
    target.addEventListener('mouseenter', () => {
      navInner.classList.add('has-hovered');
      const { left, width } = target.getBoundingClientRect();
      const headerLeft = header.getBoundingClientRect().left;

      gsap.to(hoverEl, {
        x: Math.abs(headerLeft - left),
        width,
        duration: 0.5,
        ease: 'power2.out',
      });
    });
  });
}

function coverAnimation(parent: HTMLElement) {
  const headerSticky = select('.h-header-height-sticky');
  const coverEl = select('[data-anim-el="cover-gallery"]', parent);
  if (coverEl) {
    const stickyH = headerSticky.getBoundingClientRect().height;
    const coverH = coverEl.getBoundingClientRect().height;

    gsap.to(coverEl, {
      y: `${coverH/3}px`,
      ease: 'linear',
      scrollTrigger: {
        trigger: coverEl,
        scrub: true,
        start: `top ${stickyH}px`,
        end: `bottom top`,
      }
    });
  }
}

function init(parent: HTMLElement|Document = document) {
  sectionReveal(parent as HTMLElement);
  coverAnimation(parent as HTMLElement);
}

function cleanup() {
  animations.forEach((animation: any) => {
    animation.kill(true);
  });
  animations = [];
}

bus.on('barba_enter', ({ next }) => {
  cleanup();
  requestAnimationFrame(() => {
    init(next.container);
  })
});

export default () => {
  getGsap((g, st) => {
    gsap = g;
    scrollTrigger = st;
    mm = gsap.matchMedia();
    init();
    headerBits();
  });
};
